import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from "react-helmet-async";

const VerifikasiKodeOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  
  // Mengambil nomor WhatsApp yang dikirim dari halaman Daftar
  const phonenumber = location.state?.phonenumber || '';
  const jenis = location.state?.jenis || '';

  const handleVerifikasi = async (e) => {
    e.preventDefault();
console.log({ phonenumber, otp })

    try {
      // Verifikasi OTP dan nomor WA ke backend
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/verifikasi-otp`, { phonenumber, otp });
      setSuccessMessage(response.data.message);
      setError('');
      if(jenis=="lupapassword"){
        navigate('/setlupapassword', { state: { phonenumber,otp } });

      }else{
        navigate('/daftar/setakun', { state: { phonenumber,otp } });

      }
      
    } catch (error) {
      setError(error.response?.data?.message || 'OTP tidak valid');
      setSuccessMessage('');
    }
  };

  return (
     <>
        <Helmet>
          <title>Verifikasi OTP Griya Vidya</title>
        </Helmet>
    <div>
      <div className="auth-main">
        <div className="auth-wrapper v3">
          <div className="auth-form">
            <div className="card my-5">
              <div className="card-body">
                <a href="#" className="d-flex justify-content-center">
                  <img src="/assets/images/logogvfix.png" width={200} alt="image" className="img-fluid brand-logo" />
                </a>
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <div className="auth-header">
                      <h2 className="text-secondary mt-5"><b>Kode Reset Password</b> <b>{phonenumber}</b></h2>
                      <p className="f-16 mt-2">Silahkan masukkan Kode reset Password yg diberikan oleh admin.</p>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleVerifikasi}>
                  <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)} 
                      className="form-control" 
                      id="floatingOtp" 
                      placeholder="Kode OTP" 
                    />
                    <label htmlFor="floatingOtp">Masukkan Kode OTP</label>
                  </div>
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Verifikasi</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default VerifikasiKodeOtp;
